import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosRefresh } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import Table from '../../components/Table'
import { getSchoolYearsList } from '../../actions/schoolYears'
import CustomSelect from '../../components/CustomSelect'
import { useFormik } from 'formik'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { getSchoolClassByYear, getTeachersList } from '../../actions/common'
import { Input } from '../../components/ModalInputs'
import moment from 'moment'
import { Checkbox } from '../../components/ModalInputs'
import { getLoginRegisterList, } from '../../actions/loginRegister'
import { userRole } from '../../assets/const'
import { getMethodOfficeRoles } from '../../actions/methodOffice'
import { getCurrentYearUtils } from '../../utils/classBook'
import { getGroups } from '../../actions/groups'
import { getStudents } from '../../actions/students/list'


export default function LoginRegister() {
  const dispatch = useDispatch()

  const { usefulSiteslist } = useSelector(state => state.useful_sites)
  const { groupsEnd } = useSelector(state => state.groups)
  const { teachers, lessons, classesByYear } = useSelector(state => state.common)
  const { list } = useSelector(state => state.students)
  const { studentList } = list || {}
  const { roles } = useSelector(state => state.method_office)

  const {
    values,
    setFieldValue,
    handleChange,
  } = useFormik({
    initialValues: {},
    enableReinitialize: true,
    // onSubmit: 
  })

  useEffect(() => {
    dispatch(getGroups(1))
    dispatch(getMethodOfficeRoles());
    dispatch(getTeachersList());
    dispatch(getStudents({ status: 'all' }))
    setFieldValue('from_date', moment().format('YYYY-MM-DD'))
    setFieldValue('to_date', moment().format('YYYY-MM-DD'))
  }, [])



  useEffect(() => {
    if (values.to_date) {
      // const year = getCurrentYearUtils(yearList, values.to_date)
      // dispatch(getSchoolClassByYear({ xp_key: year }))
      dispatch(getLoginRegisterList(values))
    }
  }, [values.to_date])


  const renderLi = (data) => {
    const { login, fio, groupname, login_count, login_count_parents, login_date, login_date_parents } = data
    return (
      <tr >
        <td>{login}</td>
        <td>{fio}</td>
        <td>{groupname}</td>
        <td>{login_count}</td>
        <td>{login_count_parents}</td>
        <td>{login_date}</td>
        <td>{login_date_parents}</td>
      </tr>
    )
  }

  const handleUpdateTable = () => {
    dispatch(getLoginRegisterList(values))
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>

      <h1>Журнал входов</h1>

      <div className={styles.line}>
        <div>
          <div className={styles.blockFilter}>
            <Input
              className={styles.date}
              label='Период с'
              name='from_date'
              type='date'
              value={values?.from_date}
              onChange={handleChange}
            />
            <Input
              className={styles.date}
              label='по'
              name='to_date'
              type='date'
              value={values?.to_date}
              onChange={handleChange}
            />
          </div>
          <div className={styles.blockFilter}>
            <CustomSelect
              title='Роль'
              valuesName="role"
              options={userRole}
              setFieldValue={setFieldValue}
            />
            {values.role == 1 &&
              <Checkbox
                className={styles.checkboxLogReg}
                name='not_logged'
                label='с не входившими'
                checked={values.not_logged}
                onChange={() => setFieldValue('not_logged', (!values.not_logged))}
              />
            }
          </div>

        </div>
        <div>
          <div className={styles.blockFilter}>
            <CustomSelect
              title="Класс"
              valuesName="gid"
              value={values.gid}
              options={groupsEnd && arrayForSelect(groupsEnd, 'name', 'gid')}
              setFieldValue={setFieldValue}
              width={150}
            />
            <CustomSelect
              title="Должность"
              valuesName="pmid"
              value={values.pmid}
              options={values?.role == 1 ? null : roles && arrayForSelect(roles, 'name', 'pmid')}
              setFieldValue={setFieldValue}
              disabled={values?.role == 1}
              width={300}
            />
          </div>
          <div className={styles.blockFilter}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              value={values.mid}
              options={values?.role == 1 ? studentList && arrayForSelect(studentList, 'fio', 'mid') : teachers && arrayForSelect(teachers, 'calc_fio', 'mid')}
              setFieldValue={setFieldValue}
              width={360}
            />
          </div>

        </div>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={handleUpdateTable}
        >
          <IoIosRefresh size={30} />
          Обновить
        </Button>
      </div>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>Логин</th>
            <th>ФИО</th>
            <th>Класс</th>
            <th>Количество входов</th>
            <th>Количество входов род.</th>
            <th>Дата последнего входа</th>
            <th>Дата последнего входа род.</th>
          </tr>
        </thead>
        <tbody>
          {usefulSiteslist && usefulSiteslist.map(renderLi)}
        </tbody>
      </Table>
    </div >
  )
}
